<header class="site-header">
  <nav class="navbar navbar-expand-lg main-navbar">
    <div class="container-fluid px-3 px-lg-4">
      <a class="navbar-brand d-flex align-items-center gap-2" routerLink="/">
        <img src="assets/images/logo.png" alt="UMYO Español" class="brand-logo" onerror="this.style.display='none'">
        <span class="brand-text">
          UMYO <span class="text-pink">ESPAÑOL</span>
          <small>DIRECTORY</small>
          <span class="tagline">FOR US. BY US. — POWERED BY UMYO.</span>
        </span>
      </a>

      <button class="menu-btn d-flex d-md-none navbar-toggler"
        type="button"
        (click)="isNavOpen = !isNavOpen"
        [attr.aria-expanded]="isNavOpen"
        aria-controls="navbarNav"
        aria-label="Toggle navigation"
      >
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 6h18M3 12h18M3 18h18"/>
        </svg>
      </button>

      <div class="navbar-collapse justify-content-center" id="navbarNav" [class.show]="isNavOpen">
        <ul class="navbar-nav main-nav">
          <li class="nav-item"><a class="nav-link" routerLink="/" (click)="isNavOpen = false">Home</a></li>
          <li class="nav-item"><a class="nav-link active" routerLink="/directory" (click)="isNavOpen = false">Directory</a></li>
          <li class="nav-item"><a class="nav-link " routerLink="/packages" (click)="isNavOpen = false">Packages</a></li>
          <li class="nav-item"><a class="nav-link" href="/assets/creat-card/index.html" target="_self">Creat Card</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/hardship" (click)="isNavOpen = false">Hardship Incentives</a></li>
        </ul>
      </div>

      <div class="d-none d-md-flex align-items-center gap-2">
        <div class="lang-switch">
          <button type="button" class="lang-btn" [class.active]="lang === 'en'" (click)="setLang('en')">EN</button>
          <button type="button" class="lang-btn" [class.active]="lang === 'es'" (click)="setLang('es')">ES</button>
        </div>

        <a href="/?authTab=login#login" class="btn btn-outline-pink btn-sm-pad">{{ t.nav.login }}</a>
        <a href="/?authTab=register#register" class="btn btn-pink">{{ t.nav.register }}</a>
      </div>
    </div>
  </nav>
</header>

<!-- ============ HERO (LEFT TEXT ONLY, NO SLIDER) ============ -->
<section id="hero" class="directory-hero ">
  <div class="container">
	    <div class="row">
	      <div class="col-lg-6 hero-left">
	        <span class="hero-kicker">{{ t.directory.heroKicker }}</span>

	        <h1 class="hero-title">
	          {{ t.directory.heroTitle1 }}
	          <span class="text-pink">{{ t.directory.heroTitle2 }}</span>
	        </h1>

	        <p class="hero-subtitle">
	          {{ t.directory.heroSubtitle }}
	        </p>
	      </div>
	      <div class="col-lg-6 hero-right">
	      	<div class="hs-hero-art">
            <div style="position:absolute;background: rgba(5,3,9,0.3)  ;background-size: cover;background-position: center;width: 100%;height: 100%;"></div>
	          <img src="assets/images/directory-header.png" alt="Hands holding a family, supported by the community">
	        </div>
	      </div>
	    </div>
  </div>
</section>

<!-- ============ DIRECTORY LISTING ============ -->
<section class="directory-section">
  <div class="container py-5">

    <h3 class="text-pink mb-3">{{ t.directory.searchSectionTitle }}</h3>

    <!-- TOP BAR: search + sort + view toggle -->
    <div class="directory-topbar">
      <div class="topbar-search input-icon-group">
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>
        </svg>
        <input
          type="text"
          class="form-control"
          [formControl]="searchTerm"
          [placeholder]="t.directory.searchPlaceholder"
        />
        <button type="button" class="btn btn-pink" (click)="searchMembers()">{{ t.directory.search }}</button>
      </div>

      <div class="topbar-actions">
        <div class="sort-group">
          <label>{{ t.directory.sortBy }}:</label>
          <select class="form-select" [formControl]="sortBy">
            <option value="featured">{{ t.directory.sortFeatured }}</option>
            <option value="newest">{{ t.directory.sortNewest }}</option>
            <option value="az">{{ t.directory.sortAZ }}</option>
            <option value="za">{{ t.directory.sortZA }}</option>
          </select>
        </div>

        <div class="view-toggle">
          <button
            type="button"
            class="view-btn"
            [class.active]="viewMode === 'grid'"
            (click)="viewMode = 'grid'"
            [attr.aria-label]="t.directory.gridView"
            [title]="t.directory.gridView"
          >
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/>
              <rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>
            </svg>
          </button>
          <button
            type="button"
            class="view-btn"
            [class.active]="viewMode === 'list'"
            (click)="viewMode = 'list'"
            [attr.aria-label]="t.directory.listView"
            [title]="t.directory.listView"
          >
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M8 6h13M8 12h13M8 18h13"/><circle cx="3.5" cy="6" r="1.2" fill="currentColor" stroke="none"/>
              <circle cx="3.5" cy="12" r="1.2" fill="currentColor" stroke="none"/><circle cx="3.5" cy="18" r="1.2" fill="currentColor" stroke="none"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <p class="results-count">
      {{ t.directory.showingPrefix }} {{ (currentPage - 1) * pageSize + 1 }} - {{ (currentPage - 1) * pageSize + members.length }}
      {{ t.directory.showingOf }} <span class="text-pink">{{ totalMembers }}</span> {{ t.directory.members }}
    </p>

    <div class="row gx-4">

      <!-- ============ FILTER SIDEBAR ============ -->
      <div class="col-lg-3">
        <aside class="filter-sidebar">
          <h5 class="filter-title">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 6h16M7 12h10M10 18h4"/>
            </svg>
            {{ t.directory.refineSearch }}
          </h5>

          <form [formGroup]="filterForm">

            <div class="filter-group">
              <label class="filter-label">{{ t.directory.businessType }}</label>
              <select class="form-select" formControlName="businessType">
                <option value="">{{ t.directory.allTypes }}</option>
                <option *ngFor="let item of businessType" [value]="item">{{ item }}</option>
              </select>
            </div>

            <div class="filter-group">
              <label class="filter-label">{{ t.directory.category }}</label>
              <select class="form-select" formControlName="category">
                <option value="">{{ t.directory.allCategories }}</option>
                <option *ngFor="let item of category" [value]="item">{{ item }}</option>
              </select>
            </div>

            <div class="filter-group">
              <label class="filter-label">{{ t.directory.country }}</label>
              <select class="form-select" formControlName="country">
                <option value="">{{ t.directory.allCountries }}</option>
                <option *ngFor="let item of country" [value]="item">{{ item }}</option>
              </select>
            </div>

            <div class="filter-group">
              <label class="filter-label">{{ t.directory.state }}</label>
              <select class="form-select" formControlName="state">
                <option value="">{{ t.directory.allStates }}</option>
                <option *ngFor="let item of state" [value]="item">{{ item }}</option>
              </select>
            </div>

            <div class="filter-group">
              <label class="filter-label">{{ t.directory.city }}</label>
              <select class="form-select" formControlName="city">
                <option value="">{{ t.directory.allCities }}</option>
                <option *ngFor="let item of city" [value]="item">{{ item }}</option>
              </select>
            </div>

            <div class="filter-group">
              <label class="filter-label">{{ t.directory.postalCode }}</label>
              <input type="text" class="form-control" formControlName="postalCode" [placeholder]="t.directory.postalCode" />
            </div>

            <div class="filter-group">
              <label class="filter-label">{{ t.directory.race }}</label>
              <select class="form-select" formControlName="race">
                <option value="">{{ t.directory.allRaces }}</option>
                <option *ngFor="let item of race" [value]="item">{{ item }}</option>
              </select>
            </div>

            <div class="filter-group">
              <label class="filter-label">{{ t.directory.gender }}</label>
              <select class="form-select" formControlName="gender">
                <option value="">{{ t.directory.allGenders }}</option>
                <option *ngFor="let item of gender" [value]="item">{{ item }}</option>
              </select>
            </div>

            <div class="filter-group">
              <label class="filter-label text-pink">{{ t.directory.priceRange }}</label>
              <input
                type="range"
                class="price-range"
                min="0"
                max="500"
                step="10"
                formControlName="priceRange"
              />
              <div class="price-range-labels">
                <span>$0</span>
                <span>$500+</span>
              </div>
            </div>

            <div class="filter-group">
              <label class="filter-label">{{ t.directory.features }}</label>

              <div class="form-check custom-check">
                <input type="checkbox" class="form-check-input" id="accClients" formControlName="acceptingClients">
                <label class="form-check-label" for="accClients">{{ t.directory.acceptingClients }}</label>
              </div>
              <div class="form-check custom-check">
                <input type="checkbox" class="form-check-input" id="availHire" formControlName="availableForHire">
                <label class="form-check-label" for="availHire">{{ t.directory.availableForHire }}</label>
              </div>
              <div class="form-check custom-check">
                <input type="checkbox" class="form-check-input" id="offersDisc" formControlName="offersDiscounts">
                <label class="form-check-label" for="offersDisc">{{ t.directory.offersDiscounts }}</label>
              </div>
              <div class="form-check custom-check">
                <input type="checkbox" class="form-check-input" id="verifiedOnly" formControlName="verifiedOnly">
                <label class="form-check-label" for="verifiedOnly">{{ t.directory.verifiedMembers }}</label>
              </div>
            </div>

            <button type="button" class="btn btn-pink w-100 mb-2" (click)="applyFilters()">
              {{ t.directory.applyFilters }}
            </button>
            <button type="button" class="btn-reset-filters w-100" (click)="resetFilters()">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/>
              </svg>
              {{ t.directory.resetFilters }}
            </button>

          </form>
        </aside>
      </div>

      <!-- ============ MEMBERS GRID ============ -->
      <div class="col-lg-9">

        <div class="members-grid" [class.list-view]="viewMode === 'list'">
          <div class="member-card" *ngFor="let member of members">

            <div class="card-photo-wrap">
              <span class="verified-tag" *ngIf="member.verified">{{ t.directory.verified }}</span>
              <button type="button" class="bookmark-btn" (click)="toggleBookmark(member)" aria-label="Save member">
                <svg class="icon" viewBox="0 0 24 24" [attr.fill]="member.bookmarked ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M6 3h12a1 1 0 0 1 1 1v17l-7-4-7 4V4a1 1 0 0 1 1-1Z"/>
                </svg>
              </button>
              <img [src]="member.image" [alt]="member.name" class="member-photo">
            </div>

            <div class="member-info">
              <h5>
                {{ member.name }}
                <svg class="icon verified-check" *ngIf="member.verified" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 6 9 17l-5-5"/>
                </svg>
              </h5>
              <span class="role">{{ member.role }}</span>

              <p class="location">
                <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 22s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12Z"/><circle cx="12" cy="10" r="2.5"/>
                </svg>
                {{ member.location }}
              </p>

              <div class="social-row">
                <a *ngFor="let social of member.socials" href="#" class="social-mini" [attr.aria-label]="social.label">
                  <i>{{ social.icon }}</i>
                </a>
              </div>

              <a [routerLink]="'/profile/' + member.id" class="btn btn-outline-pink w-100">{{ t.directory.viewProfile }}</a>
            </div>

          </div>
        </div>

        <!-- ============ PAGINATION ============ -->
        <div class="pagination-bar">
          <button type="button" class="page-btn" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </button>

          <button
            type="button"
            class="page-btn"
            *ngFor="let p of visiblePages"
            [class.active]="p === currentPage"
            (click)="goToPage(p)"
          >{{ p }}</button>

          <span class="page-dots" *ngIf="totalPages > visiblePages.length + 1">...</span>

          <button
            type="button"
            class="page-btn"
            *ngIf="totalPages > visiblePages.length"
            [class.active]="currentPage === totalPages"
            (click)="goToPage(totalPages)"
          >{{ totalPages }}</button>

          <button type="button" class="page-btn" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
        </div>

      </div>
    </div>
  </div>
</section>

<!-- ============ FIND THE PEOPLE YOU NEED ============ -->
<section class="cta-banner-section">
  <div class="container pb-5 pt-3">
    <div class="cta-banner">
      <div class="cta-icon">
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>
        </svg>
      </div>
      <div class="cta-text">
        <h4>{{ t.directory.findTitle }}</h4>
        <p class="mb-0">{{ t.directory.findSubtitle }}</p>
      </div>
      <a routerLink="/directory" class="btn btn-pink cta-btn">
        {{ t.directory.exploreProfiles }}
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 12h14"/><path d="M13 5l7 7-7 7"/>
        </svg>
      </a>
    </div>
  </div>
</section>

<!-- ============ BOTTOM CTA BANNER ============ -->
<section class="cta-banner-section">
  <div class="container pb-5">
    <div class="cta-banner">
      <div class="cta-icon">
        <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 36 36">
          <path d="M0 0h36v36H0z" fill="none" />
          <path fill="#E4002B" d="M17.9 17.3c2.7 0 4.8-2.2 4.8-4.9s-2.2-4.8-4.9-4.8S13 9.8 13 12.4c0 2.7 2.2 4.9 4.9 4.9m-.1-7.7q.15 0 0 0c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.8-2.9 2.8S15 14 15 12.5c0-1.6 1.3-2.9 2.8-2.9" class="clr-i-outline clr-i-outline-path-1" />
          <path fill="#E4002B" d="M32.7 16.7c-1.9-1.7-4.4-2.6-7-2.5h-.8q-.3 1.2-.9 2.1c.6-.1 1.1-.1 1.7-.1c1.9-.1 3.8.5 5.3 1.6V25h2v-8z" class="clr-i-outline clr-i-outline-path-2" />
          <path fill="#E4002B" d="M23.4 7.8c.5-1.2 1.9-1.8 3.2-1.3c1.2.5 1.8 1.9 1.3 3.2c-.4.9-1.3 1.5-2.2 1.5c-.2 0-.5 0-.7-.1c.1.5.1 1 .1 1.4v.6c.2 0 .4.1.6.1c2.5 0 4.5-2 4.5-4.4c0-2.5-2-4.5-4.4-4.5c-1.6 0-3 .8-3.8 2.2c.5.3 1 .7 1.4 1.3" class="clr-i-outline clr-i-outline-path-3" />
          <path fill="#E4002B" d="M12 16.4q-.6-.9-.9-2.1h-.8c-2.6-.1-5.1.8-7 2.4L3 17v8h2v-7.2c1.6-1.1 3.4-1.7 5.3-1.6c.6 0 1.2.1 1.7.2" class="clr-i-outline clr-i-outline-path-4" />
          <path fill="#E4002B" d="M10.3 13.1c.2 0 .4 0 .6-.1v-.6c0-.5 0-1 .1-1.4c-.2.1-.5.1-.7.1c-1.3 0-2.4-1.1-2.4-2.4S9 6.3 10.3 6.3c1 0 1.9.6 2.3 1.5c.4-.5 1-1 1.5-1.4c-1.3-2.1-4-2.8-6.1-1.5s-2.8 4-1.5 6.1c.8 1.3 2.2 2.1 3.8 2.1" class="clr-i-outline clr-i-outline-path-5" />
          <path fill="#E4002B" d="m26.1 22.7l-.2-.3c-2-2.2-4.8-3.5-7.8-3.4c-3-.1-5.9 1.2-7.9 3.4l-.2.3v7.6c0 .9.7 1.7 1.7 1.7h12.8c.9 0 1.7-.8 1.7-1.7v-7.6zm-2 7.3H12v-6.6c1.6-1.6 3.8-2.4 6.1-2.4c2.2-.1 4.4.8 6 2.4z" class="clr-i-outline clr-i-outline-path-6" />
          <path fill="none" d="M0 0h36v36H0z" />
        </svg>
      </div>
      <div class="cta-text">
        <h4>
          {{ t.directory.ctaTitle1 }}<br>
          <span class="text-pink">{{ t.directory.ctaTitle2 }}</span>
        </h4>
        <p class="mb-0">
          {{ t.directory.ctaSubtitle }}
        </p>
      </div>
      <a href="/?authTab=register#register" class="btn btn-outline-pink cta-btn">
        {{ t.nav.register }}
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 12h14"/><path d="M13 5l7 7-7 7"/>
        </svg>
      </a>
      <div class="back-img">
        <img src="assets/images/dir-footer-img.png" style="width: 100%">
      </div>
    </div>
  </div>
</section>
<!-- ============ FOOTER ============ -->
<footer class="site-footer pkg-footer">
  <div class="container-fluid px-3 px-lg-4">
    <div class="row py-5">

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <div class="d-flex align-items-center gap-2 mb-2">
          <img src="assets/images/logo.png" alt="UMYO Español" class="brand-logo" onerror="this.style.display='none'">
          <div class="brand-text">UMYO <span class="text-pink">ESPAÑOL</span></div>
        </div>
        <small class="d-block pkg-footer-muted">{{ t.footer.tagline }}</small>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">{{ t.footer.quickLinks }}</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/">Home</a></li>
          <li><a routerLink="/directory">Directory</a></li>
          <li><a routerLink="/packages">Packages</a></li>
          <li><a routerLink="/hardship">Incentives</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">{{ t.footer.resources }}</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/services">Services</a></li>
          <li><a routerLink="#">How To</a></li>
          <li><a routerLink="/hardship">Hardship Incentives</a></li>
          <li><a href="/privacy">Privacy Policy</a></li>
          <li><a href="/terms">Terms of Service</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6">
        <h6 class="pkg-footer-heading">{{ t.footer.connect }}</h6>
        <div class="social-icons justify-content-start">
          <a href="#" aria-label="Instagram">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="TikTok">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 3v11.5a3.5 3.5 0 1 1-3-3.46"/><path d="M14 3c.4 2.6 2.2 4.4 5 4.8"/>
            </svg>
          </a>
          <a href="#" aria-label="YouTube">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="5" width="20" height="14" rx="4"/><path d="M10 9l6 3-6 3V9Z" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="Facebook">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3Z"/>
            </svg>
          </a>
          <a href="#" aria-label="X">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4l16 16M20 4 4 20"/>
            </svg>
          </a>
        </div>
      </div>

    </div>

    <div class="pkg-footer-bottom text-center py-3">
      <small>{{ t.footer.copyright }}</small>
    </div>
  </div>
</footer>